import {
  jb_social_icons_css_default
} from "./chunk.DJOB74YQ.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n,
  r as r2
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-social-icons/jb-social-icons.ts
var JbSocialIcons = class extends r {
  constructor() {
    super(...arguments);
    this.align = "center";
    this.ARIALABELS_DEFAULT = {
      bluesky: "BlueSky",
      facebook: "Facebook",
      instagram: "Instagram",
      linkedin: "LinkedIn",
      mail: "Mail",
      x: "X",
      youtube: "YouTube"
    };
    this.items = void 0;
    this._renderedIcons = [];
  }
  connectedCallback() {
    super.connectedCallback();
    this._loadIcons().then();
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    if (changedProperties.has("items")) {
      this._loadIcons().then();
    }
  }
  _clickSocialIcon(event, service, context) {
    this.dispatchEvent(
      new CustomEvent("jb-social-icons:clicked", {
        detail: { service, context },
        bubbles: true,
        composed: true
      })
    );
  }
  /**
   * Returns the corresponding social icon custom element based on the service name.
   * Dynamically imports the necessary icon component.
   */
  async _getSocialIcon(service) {
    switch (service) {
      case "bluesky":
        await import("../components/icons/jb-bluesky-icon/jb-bluesky-icon.js");
        return `<jb-bluesky-icon></jb-bluesky-icon>`;
      case "email":
      case "mail":
        await import("../components/icons/jb-mail-icon/jb-mail-icon.js");
        return `<jb-mail-icon></jb-mail-icon>`;
      case "facebook":
        await import("../components/icons/jb-facebook-icon/jb-facebook-icon.js");
        return `<jb-facebook-icon></jb-facebook-icon>`;
      case "instagram":
        await import("../components/icons/jb-instagram-icon/jb-instagram-icon.js");
        return `<jb-instagram-icon></jb-instagram-icon>`;
      case "linkedin":
        await import("../components/icons/jb-linkedin-icon/jb-linkedin-icon.js");
        return `<jb-linkedin-icon></jb-linkedin-icon>`;
      case "x":
        await import("../components/icons/jb-x-icon/jb-x-icon.js");
        return `<jb-x-icon></jb-x-icon>`;
      case "youtube":
        await import("../components/icons/jb-youtube-icon/jb-youtube-icon.js");
        return `<jb-youtube-icon></jb-youtube-icon>`;
      default:
        return "";
    }
  }
  async _loadIcons() {
    this._renderedIcons = await this._renderSocialIcons();
    this.requestUpdate();
  }
  /**
   * Maps each social icon option to a list item that contains an anchor element with the icon.
   */
  async _renderSocialIcons() {
    if (!this.items) return [];
    const iconPromises = this.items.map(async (item) => {
      const iconHtml = await this._getSocialIcon(item.service);
      const anchor = document.createElement("jb-anchor");
      anchor.setAttribute("data-fly-padding", "0");
      anchor.link = item.link;
      anchor.innerHTML = iconHtml;
      anchor.classList.add("link");
      anchor.ariaLabels = item.ariaLabels ?? { label: this.ARIALABELS_DEFAULT[item.service] ?? D };
      return {
        anchor,
        service: item.service,
        item
      };
    });
    const loadedIcons = await Promise.all(iconPromises);
    return loadedIcons.map(
      ({ anchor, service, item }) => ke`<li
          class="${service}"
          @click=${(e) => this._clickSocialIcon(e, service, item)}
        >
          ${anchor}
        </li>`
    );
  }
  render() {
    return ke`
      <ul class="${Rt({ [this.align]: this.align !== "center" })}">
        ${this._renderedIcons}
      </ul>
    `;
  }
};
JbSocialIcons.styles = [reset_css_default, jb_social_icons_css_default];
__decorateClass([
  n()
], JbSocialIcons.prototype, "align", 2);
__decorateClass([
  n({ type: Array })
], JbSocialIcons.prototype, "items", 2);
__decorateClass([
  r2()
], JbSocialIcons.prototype, "_renderedIcons", 2);
JbSocialIcons = __decorateClass([
  customElement("jb-social-icons")
], JbSocialIcons);

export {
  JbSocialIcons
};
